module.exports = __webpack_public_path__ + "img/020.449aeda7.png";